export default __webpack_public_path__ + "static/media/design-system.354189a0.jpg";